import { NotFoundIcon } from '@/assets/icons';

export const NotFound = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <NotFoundIcon className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-primary-darkest mt-10 mb-3">
        Oops! Page Not Found
      </h1>
      <span className="font-medium text-base text-neutral-7">
        Sorry, we can&apos;t find the page you&apos;re looking for.
      </span>
    </div>
  );
};
